import { css } from '@emotion/css';

import { Color, Font, Spacing, TextAlign } from '../../styles';

export const menuName = css`
  ${Font.h4}
  color: ${Color.Brand6};
  ${Spacing.mt64}
  ${Spacing.ml80}
`;

export const formCard = css`
  border: none;
  box-shadow: 0rem 0.25rem 1rem rgba(2, 85, 163, 0.15);
  ${Spacing.p24}
  ${Spacing.mt24}
  border-radius: 0.5rem;
  ${Spacing.mb24}
`;

export const noIndicationText = css`
  line-height: 22px;
  ${TextAlign.center}
  color: ${Color.Gray9};
  margin-top: 16px;
`;

export const noIndicationsContainer = css`
  margin-top: 186px;
  ${TextAlign.center}
`;
